import { render, staticRenderFns } from "./FarmsListController.vue?vue&type=template&id=03dcad0a&scoped=true&"
import script from "./FarmsListController.vue?vue&type=script&lang=ts&"
export * from "./FarmsListController.vue?vue&type=script&lang=ts&"
import style0 from "./farm-list-controller.scss?vue&type=style&index=0&id=03dcad0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dcad0a",
  null
  
)

export default component.exports